module.exports = __webpack_public_path__ + "static/media/quoteMachine.eddf4618.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/quoteMachine.jpg
// module id = 76
// module chunks = 0